import { render, staticRenderFns } from "./Industry.vue?vue&type=template&id=da5df94a&scoped=true&"
import script from "./Industry.vue?vue&type=script&lang=javascript&"
export * from "./Industry.vue?vue&type=script&lang=javascript&"
import style0 from "./Industry.vue?vue&type=style&index=0&id=da5df94a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5df94a",
  null
  
)

export default component.exports